/* ============================================================
   zuiver.js — zet de leesstand aan: de weglating ter hoogte van je ogen staat
   vol, de andere een stap terug, en op de haarlijn schuift een segment mee.

   Wat dit bestand WEL doet: één keer per beeldverversing uitrekenen welke
   weglating het dichtst bij de leeslijn staat, en die ene keuze doorgeven aan
   CSS (een attribuut en twee variabelen).

   Wat dit bestand NIET doet: de scroll overnemen. Er wordt nergens een
   scroll-event afgebroken en nergens `scrollTo` aangeroepen. De pagina blijft
   een pagina — met een toetsenbord, een trackpad met vaart en een schermlezer.

   DE LEESLIJN ligt op 42 % van het venster onder de kop, niet in het midden.
   Gemeten op 1440 × 900 met de kop van 111 px: het midden van de rest ligt op
   505 px, de leeslijn op 442. Wie leest kijkt boven het midden, en met de lijn
   in het midden sprong de focus pas over naar de volgende weglating als je die
   al half gelezen had. Op 390 × 844 valt 42 % op 419 px en klopt hetzelfde.

   Zonder JavaScript, en met "minder beweging" aan, gebeurt hier niets en
   staat de sectie in de stille stand van zuiver.css.
   ============================================================ */
(function () {
  'use strict';
  if (window.__zuiver) return;   // de sectie laadt zijn eigen script; twee keer is niets
  window.__zuiver = true;

  var stil = window.matchMedia('(prefers-reduced-motion: reduce)');
  var LEESLIJN = 0.42;

  function Zuiver(wortel) {
    this.wortel = wortel;
    this.lijst = wortel.querySelector('[data-zuiver-lijst]');
    this.merk = wortel.querySelector('[data-zuiver-merk]');
    this.regels = [].slice.call(wortel.querySelectorAll('[data-zuiver-weglating]'));
    this.actief = null;
    this.wacht = false;
    this.aan();
  }

  /* ---------- de stap ---------- */

  Zuiver.prototype.stap = function () {
    this.wacht = false;
    if (stil.matches || !this.wortel.classList.contains('zuiver--leest')) return;
    if (!this.regels.length) return;

    // De hoogte van de kop komt uit header.js; ontbreekt die, dan is nul de
    // eerlijke terugval en ligt de leeslijn iets te hoog — nooit buiten beeld.
    var kop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-group-height')) || 0;
    var lijn = kop + (window.innerHeight - kop) * LEESLIJN;

    // De weglating die de leeslijn snijdt wint; snijdt niemand hem (tussen twee
    // regels in, of de sectie is nog niet in beeld), dan de dichtstbijzijnde.
    var beste = null, besteAfstand = Infinity;
    for (var i = 0; i < this.regels.length; i++) {
      var r = this.regels[i].getBoundingClientRect();
      var afstand = lijn < r.top ? r.top - lijn : lijn > r.bottom ? lijn - r.bottom : 0;
      if (afstand < besteAfstand) { besteAfstand = afstand; beste = this.regels[i]; }
    }

    if (beste !== this.actief) {
      if (this.actief) this.actief.removeAttribute('data-actief');
      beste.setAttribute('data-actief', '');
      this.actief = beste;
      // offsetTop is relatief aan de lijst, want die staat op position: relative;
      // dat is precies het assenstelsel waarin het merk getekend wordt.
      this.wortel.style.setProperty('--zuiver-merk-y', beste.offsetTop + 'px');
      this.wortel.style.setProperty('--zuiver-merk-h', beste.offsetHeight + 'px');
    }
  };

  Zuiver.prototype.plan = function () {
    if (this.wacht) return;
    this.wacht = true;
    var zelf = this;
    requestAnimationFrame(function () { zelf.stap(); });
  };

  /* ---------- aan- en uitzetten ---------- */

  Zuiver.prototype.aan = function () {
    var zelf = this;
    this._plan = function () { zelf.plan(); };
    this._meet = function () {
      // Bij een andere breedte verandert de hoogte van elke regel, dus het
      // merk moet opnieuw gemeten worden ook als de actieve regel dezelfde is.
      zelf.actief = null;
      zelf.plan();
    };

    // De leesstand is van JS. Zonder script, en met "minder beweging" aan,
    // blijft de sectie in de stille stand en is er niets stuk.
    if (stil.matches || !this.lijst || !this.merk) return;
    this.wortel.classList.add('zuiver--leest');

    addEventListener('scroll', this._plan, { passive: true });
    addEventListener('resize', this._meet, { passive: true });
    if ('ResizeObserver' in window) {
      this.rw = new ResizeObserver(this._meet);
      this.rw.observe(this.lijst);
    }
    this.stap();
  };

  Zuiver.prototype.uit = function () {
    removeEventListener('scroll', this._plan);
    removeEventListener('resize', this._meet);
    if (this.rw) { this.rw.disconnect(); this.rw = null; }
    this.wortel.classList.remove('zuiver--leest');
    this.wortel.style.removeProperty('--zuiver-merk-y');
    this.wortel.style.removeProperty('--zuiver-merk-h');
    if (this.actief) this.actief.removeAttribute('data-actief');
    this.actief = null;
  };

  /* ---------- opstarten ---------- */

  var lopend = [];

  function start(bereik) {
    var wortels = (bereik || document).querySelectorAll('[data-zuiver]');
    [].forEach.call(wortels, function (w) {
      if (w.__zuiver) return;
      w.__zuiver = true;
      lopend.push(new Zuiver(w));
    });
  }

  start();

  // De bezoeker zet "minder beweging" aan of uit terwijl de pagina openstaat.
  var wissel = function () {
    lopend.forEach(function (z) { if (stil.matches) z.uit(); else z.aan(); });
  };
  if (stil.addEventListener) stil.addEventListener('change', wissel);
  else if (stil.addListener) stil.addListener(wissel);

  // De thema-editor plaatst en herlaadt secties zonder de pagina te verversen.
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    lopend = lopend.filter(function (z) {
      if (e.target.contains(z.wortel)) { z.uit(); return false; }
      return true;
    });
  });
})();
